import React, { useMemo } from "react";
import ReactApexChart from "react-apexcharts";

const DEFAULT_HEIGHT = 350;

const ComponentChangeChart = ({ changeData, measurementUnits, height = DEFAULT_HEIGHT }) => {
  const dataPoints = useMemo(() => {
    if (!Array.isArray(changeData) || changeData.length === 0) {
      return [];
    }

    const parsedEntries = changeData
      .map((entry) => {
        const rawDate = entry?.date ?? entry?.completedAt ?? entry?.changedAt;
        const dateValue = rawDate ? new Date(rawDate).getTime() : null;
        const workOrderCount = entry?.count ?? entry?.workOrderCount ?? entry?.componentCount;
        const numericCount = workOrderCount != null ? Number(workOrderCount) : null;

        if (!Number.isFinite(dateValue) || !Number.isFinite(numericCount)) {
          return null;
        }

        return { timestamp: dateValue, count: numericCount };
      })
      .filter(Boolean)
      .sort((a, b) => a.timestamp - b.timestamp);

    if (parsedEntries.length === 0) {
      return [];
    }

    return parsedEntries.map((entry) => ({ x: entry.timestamp, y: entry.count }));
  }, [changeData]);

  if (dataPoints.length === 0) {
    return <div className="text-muted ms-16 mt-16">No component change data available.</div>;
  }

  const chartOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
    },
    legend: { show: false },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
      },
    },
    xaxis: {
      type: "datetime",
      title: { text: "Date" },
      labels: {
        datetimeFormatter: {
          year: "dd MMM yyyy",
          month: "dd MMM",
          day: "dd MMM",
        },
      },
    },
    yaxis: {
      title: { text: "Count of Work Orders" },
      forceNiceScale: true,
    },
    dataLabels: { enabled: false },
    tooltip: {
      x: { format: "dd MMM yyyy" },
      y: {
        formatter: (value) => value?.toLocaleString?.(),
      },
    },
    colors: ["#008FFB"],
  };

  const series = [
    {
      name: `Work Orders${measurementUnits ? ` (${measurementUnits})` : ""}`,
      data: dataPoints,
    },
  ];

  return <ReactApexChart options={chartOptions} series={series} type="bar" height={height} />;
};

export default ComponentChangeChart;
